import * as React from 'react';
import { TextInput, TextInputProps } from './TextInput';
import emailValidator from '@th/shared/src/validators/emailValidator';

interface Props extends Omit<TextInputProps, 'id'> {
  id?: string;
  email: string;
  setEmail: (email: string) => void;
  showValid?: boolean;
  showInvalid?: boolean;
}

export default function EmailTextInput({
  id = 'email',
  email,
  setEmail,
  placeholder = 'jane@example.com',
  showValid,
  showInvalid,
  ...props
}: Props) {
  const isEmailValid = emailValidator.required().isValidSync(email);
  return (
    <TextInput
      id={id}
      type={'email'}
      value={email}
      placeholder={placeholder}
      onChange={e => setEmail(e.target.value)}
      isValid={showValid && isEmailValid}
      isInvalid={showInvalid && !isEmailValid}
      {...props}
    />
  );
}
